import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BASE_URL, { getImageUrl } from "../../BASEURL";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/category`);
      const data = await response.json();
      setCategories(data.data || []);
    } catch (err) {
      console.error("Fetch categories error:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    try {
      await fetch(`${BASE_URL}/api/category/${id}`, { method: "DELETE" });
      setCategories((prev) => prev.filter((category) => category._id !== id));
    } catch (err) {
      console.error("Delete category error:", err);
    }
  };

  if (loading) return <div>Loading categories...</div>;

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Categories</h2>
        <Link to="/admin/categories/add" className="bg-blue-600 text-white px-4 py-2 rounded">
          Add Category
        </Link>
      </div>

      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-2 border-r">Image</th>
              <th className="p-2 border-r">Name</th>
              <th className="p-2 border-r">Status</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category._id} className="border-b hover:bg-gray-50">
                <td className="p-2 border-r">
                  <img
                    src={getImageUrl(category.image, "https://via.placeholder.com/60")}
                    alt={category.name}
                    className="h-12 w-12 object-cover border"
                  />
                </td>
                <td className="p-2 border-r font-bold">{category.name}</td>
                <td className="p-2 border-r">
                  {category.isActive ? (
                    <span className="text-green-600 font-bold">Active</span>
                  ) : (
                    <span className="text-red-600 font-bold">Inactive</span>
                  )}
                </td>
                <td className="p-2 space-x-2">
                  <button
                    onClick={() => navigate(`/admin/categories/edit/${category._id}`)}
                    className="text-blue-600 hover:underline"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => deleteCategory(category._id)}
                    className="text-red-600 hover:underline"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {categories.length === 0 && (
              <tr>
                <td colSpan="4" className="p-4 text-center">No categories found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
